<template>
  <v-dialog v-model="dialog" persistent fullscreen>
    <v-toolbar>
      <v-toolbar-title
        ><v-icon>mdi-receipt</v-icon>
        {{ $route.query.name_agent_extract }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <div>
        <div class="pt-6 pb-3 px-2">
          <Range />
          <div class="mx-2 mb-3">
            <GroupExport />
          </div>
          <div class="text-right px-2">
            <v-btn class="info" small @click="save()">
              <v-icon small left>mdi-filter</v-icon>{{ $t("btnFilter") }}
            </v-btn>
          </div>
        </div>
        <v-divider></v-divider>
        <div id="print-report-extract">
          <!-- Print Only -->
          <div class="caption d-none d-print-block mb-3">
            <div class="overline font-weight-bold">
              {{ $t("extractLabel") }}
            </div>
            <div>
              {{ $t("agentLabel") }} {{ $route.query.name_agent_extract }} |
              {{ $t("idLabel") }}:
              {{ $route.params.id_agent_extract }}
            </div>
            <div>{{ $t("periodLabel") }} {{ rangeDateUi }}</div>
            <div>
              {{ $t("consultedBy") }}
              {{ $localStorage.getItem("user_data").nome_usuario }} |
              {{ $t("labelLogin") }}
              {{ $localStorage.getItem("user_data").login }} |
              {{ $t("printDate") }} {{ new Date().toLocaleString() }}
            </div>
          </div>
          <!-- end/ Print Only -->
          <v-card elevation="0">
            <div class="pa-4 py-0">
              <v-row class="align-center">
                <v-col cols="'12" md="9">
                  <v-btn
                    small
                    class="white black--text d-print-none"
                    @click="$printReportExtract()"
                  >
                    <v-icon small left>mdi-printer</v-icon>
                    {{ $t("btnPrint") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="title text-right py-2">
                    {{ $t("previousBalance") }}: {{ $t("labelCurrency") }}
                    {{ previusBalance }}
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <!-- Card Table -->
            <v-card>
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="-1"
                hide-default-footer
                :mobile-breakpoint="breakpoint"
                :footer-props="{
                  'items-per-page-text': this.$t('rowsPerPage'),
                }"
              >
                <!-- Values -->
                <template
                  v-for="(value, index) in valueColors"
                  v-slot:[`item.${value}`]="{ item }"
                >
                  <span
                    class="caption"
                    :key="index"
                    :class="getColor(item[value])"
                    >{{ item[value] }}</span
                  >
                </template>
              </v-data-table>
            </v-card>
            <!-- Resume -->
            <div class="mt-4" v-if="items.length != 0">
              <v-row>
                <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
                <v-col cols="12" xs="12" sm="6" md="4">
                  <v-card class="pa-3">
                    <div class="subtitle-1 mb-2">
                      {{ $t("periodSummary") }}
                      <div class="caption">{{ $store.state.rangeUI }}</div>
                    </div>
                    <v-simple-table>
                      <template v-slot:default>
                        <tbody>
                          <tr
                            v-for="(item, index) in keysResume"
                            :key="`${index} ${Math.random()}`"
                          >
                            <td class="caption">{{ TranslateKey(item) }}</td>
                            <td
                              class="text-right"
                              :class="resume[item].classColor"
                            >
                              {{ resume[item].value }}
                            </td>
                          </tr>
                          <tr>
                            <td class="caption">{{ $t("balance") }}</td>
                            <td
                              class="text-right"
                              :class="
                                getColor(items[items.length - 1].balance_final)
                              "
                            >
                              {{ items[items.length - 1].balance_final }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- <div v-show="progress" class="text-center pa-4">
              <v-progress-circular indeterminate></v-progress-circular>
            </div> -->

            <v-alert class="ma-4" v-show="alert" type="warning" dense outlined>
              {{ $t("extractAgentAlert") }} {{ rangeDateUi }}
            </v-alert>
          </v-card>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Range from "@/components/common/filters/Range.vue";
import GroupExport from "@/components/common/filters/GroupExport.vue";
export default {
  name: "local-manager-financial-collection-extract-agent",
  components: {
    Range,
    GroupExport,
  },
  data: () => ({
    breakpoint: "xs",
    alert: false,
    resume: null,
    keysResume: [],
    items: [],
    valueColors: [
      "sales",
      "commission",
      "cancellations",
      "prizes_paid",
      "deals",
      "balance",
      "balance_final",
    ],
    previusBalance: "",
  }),
  mounted() {
    this.$store.state.filters.groupExport.value = "";
    this.balanceAgent();
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    rangeDateUi() {
      return this.$store.state.rangeUI;
    },
    headers() {
      return [
        { text: this.$t("dateHeader"), value: "date_entry" },
        { text: this.$t("qtdLabel"), value: "count" },
        { text: this.$t("sales"), value: "sales" },
        { text: this.$t("commissionSales"), value: "commission" },
        { text: this.$t("cancellations"), value: "cancellations" },
        { text: this.$t("paidPrizes"), value: "prizes_paid" },
        { text: this.$t("deals"), value: "deals" },
        { text: this.$t("dailyBalance"), value: "balance" },
        { text: this.$t("balance"), value: "balance_final" },
      ];
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async balanceAgent() {
      this.progress = true;
      this.alert = false;
      this.extract = [];

      const body = {
        ...this.rangeDate,
        id_agent: this.$route.params.id_agent_extract,
        export: this.exportDoc,
      };

      let response;

      // Request Download DOC (Excel)
      if (this.exportDoc) {
        const extension = this.exportDoc;
        await this.$request.exportDoc(
          "/localManager/financial/balanceAgent",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/localManager/financial/balanceAgent",
          body
        );
      }

      if (response.length != 0) {
        this.previusBalance = response.dados.balance;
        this.items = response.dados.extract;
        this.items.forEach((item) => {
          item.date_entry = new Date(
            `${item.date_entry}T03:00:00.000Z`
          ).toLocaleDateString();
        });
        const data = this.buildBalanceFinal(this.items, this.previusBalance);
        this.buildResume(data);
      } else {
        this.items = [];
        this.alert = true;
      }

      // this.progress = false;
    },

    buildResume(data) {
      if (!data) return;

      // SOMANDO
      const sum = (key) => {
        return data
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      // CHAVES QUE DEVEM SER SOMADAS
      let resume = {
        sales: {},
        commission: {},
        cancellations: {},
        prizes_paid: {},
        deals: {},
        balance: {},
      };

      // CONSTRUINDO O OBJETO DE RESUMO
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
      });

      // COMPLEMENTANDO COM QUANTIDADE
      const complement = {
        count: { value: Number(sum("count")) },
      };

      // ARMAZENANDO PARA EXIBIR NA UI
      this.resume = { ...complement, ...resume };
      this.keysResume = Object.keys(this.resume);
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    // Constructor Balance Final
    buildBalanceFinal(resultExtract, previousBalance) {
      let balance_final = previousBalance;
      let extract = resultExtract.map((element) => {
        balance_final = (
          Number(element.balance) + Number(balance_final)
        ).toFixed(2);
        element.balance_final = balance_final;
        return element;
      });
      return extract;
    },

    save() {
      this.balanceAgent();
    },

    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        count: this.$t("qtdLabel"),
        sales: this.$t("sales"),
        commission: this.$t("commissionSales"),
        cancellations: this.$t("cancellations"),
        prizes_paid: this.$t("paidPrizes"),
        deals: this.$t("deals"),
        balance: this.$t("dailyBalance"),
      };

      return myKeysTranslated[key] || null;
    },
  },
};
</script>
<style scoped>
tbody.extract-table tr:last-child {
  text-transform: uppercase;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.1);
}
</style>
